import { CustomerType } from './customer.interface';

export interface AuthResponse {
  response: AuthResponseData;
}

export interface AuthResponseData {
  status: string;
  message: string;
  user: User;
}

export interface User {
  id: number;
  name: string;
  username: string;
  email: string;
  email_verified_at: string | null;
  is_admin: boolean | number;
  created_at: string;
  updated_at: string;
}

export interface UserRegistration {
  customer_type: CustomerType;
  username: string;
  email: string;
  password: string;
  password_confirmation: string;
}

export interface AdminUserCreateParams {
  customer_nr: number;
  username: string;
}

export interface AdminUserUpdateParams {
  user_id: number;
  username: string;
}
